import Swiper, { Navigation } from 'swiper'

const nodeSliders = document.querySelectorAll('.js-slider-products')
if (nodeSliders.length) {
	nodeSliders.forEach(item => {
		const prev = item.parentNode.querySelector('.js-slider-products-prev')
		const next = item.parentNode.querySelector('.js-slider-products-next')

		new Swiper(item, {
			modules: [Navigation],
			slidesPerView: "auto",
			loop: true,
			navigation: {
				nextEl: next,
				prevEl: prev
			}
		})
	})
}
